import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {HttpService} from "../shared/http.service";

@Component({
  selector: 'my-pages',
  template: require('./about.component.html'),
  styles: [require('./about.component.scss')]
})
export class MyPagesComponent implements OnInit, OnDestroy  {

  private url: string;
  private titleMenu: string;
  private fullPath: Array<string>;
  private posts: Array<object>;
  private pageContent: object;
  private pages: object;
  private changePageRequest: boolean;
  private newsPreloader: boolean;
  private pagePreloader: boolean;
  private categoryMenus: any;

  constructor(private app: AppComponent, private http: HttpService) {
    this.fullPath = [];
    this.titleMenu = '';
    this.pageContent = {};
  }

  ngOnInit() {
    this.pages = {};
    this.update(this.app.route);
    this.updateTitle();
    this.checkPage();
    this.categoryMenus = this.app.categoryMenus;
    this.app.path.subscribe(e => {
      this.update(e['url']);
      this.updateTitle();
      this.checkPage();
    });
  }

  ngOnDestroy() {
  }

  checkPage() {
    if (this.fullPath[1] && !this.fullPath[2]) {
      if (!this.pages[this.fullPath[1]] && !this.changePageRequest) {
        let pageUrl = '?json=get_page&slug=' + this.fullPath[1];
        this.pagePreloader = true;
        this.http.get(pageUrl).subscribe(
          data => {
            this.pages[this.fullPath[1]] = data['page'];
            this.pageContent = data['page'];
            this.changePageRequest = true;
            this.pagePreloader = false;
          },
          err => {
            this.changePageRequest = false;
            this.pagePreloader = false;
            console.log(err);
          });
      }else {
        this.pageContent = this.pages[this.fullPath[1]];
      }
    }
  }

  updateTitle() {
    for (let i in this.app.menu) {
      let menu = this.app.menu[i];
      if (menu['value'].indexOf(this.fullPath[1]) !== -1) {
        this.titleMenu = menu['name'];
      }
    }
  }

  update(url) {
    if (url != this.url) {
      this.url = url;
      let fullPath = url.split('/');
      if (this.fullPath.length === 0) {
        if (this.fullPath[1] != fullPath[1]) {
          this.fullPath = fullPath;
          this.doNewResponse();
          return;
        }
        this.fullPath = fullPath;
      }
      if (this.fullPath[1] != fullPath[1]) {
        this.fullPath = fullPath;
        this.doNewResponse();
      }else if (this.fullPath[1] === fullPath[1] && this.fullPath[2] != fullPath[2]) {
        this.fullPath = fullPath;
      }
    }
    this.getFromPrevResp();
  }

  getMore(url, page) {
    let newUrl = url + '&page=' + page;
    this.newsPreloader = true;
    this.http.get(newUrl).subscribe(
      data => {
        this.posts = this.posts.concat(data['posts']);
        this.app[this.fullPath[1]] = this.posts;
        this.getFromPrevResp();
        this.newsPreloader = false;
        if (data['pages'] && data['pages'] > page) {
          page++;
          this.getMore(url, page);
        }
      },
      err => {
        console.log(err);
        this.newsPreloader = false;
      });
  }

  doNewResponse() {
    if (this.fullPath[1]) {
      let url = `?json=get_category_posts&slug=${this.fullPath[1]}&status=publish`;

      if (this.app[this.fullPath[1]] && this.app[this.fullPath[1]].length > 0) {
        this.posts = this.app[this.fullPath[1]];
        this.getFromPrevResp();
        return;
      }

      this.newsPreloader = true;
      this.http.get(url).subscribe(
        data => {
          this.posts = data['posts'];
          if (this.app[this.fullPath[1]]) {
            this.app[this.fullPath[1]] = this.posts;
          }
          this.getFromPrevResp();
          this.newsPreloader = false;
          if (data['pages'] && data['pages'] > 1) {
            this.getMore(url, 2);
          }
        },
        err => {
          console.log(err);
          this.newsPreloader = false;
        });
    }
  }

  getFromPrevResp() {
    if (this.fullPath[2]) {
      this.pageContent = {};
      for (let i in this.posts) {
        let post = this.posts[i];
        if (Number(post['id']) === Number(this.fullPath[2])) {
          this.pageContent = post;
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/about/about.component.ts